import type { LegalSection } from "@serophin/shared";
import { CONTACT_US, PRIVACY_POLICY } from "./app";

export const TERMS_LAW: LegalSection[] = [
  {
    heading: "International Use",
    blocks: [
      "The Service is controlled and operated from Australia, but hosted on servers located in the United States.",
      "We make no representation that the Service is appropriate or available for use in all locations. If you access the Service from outside Australia, you are responsible for compliance with local laws.",
      "You may not use or export the Service in violation of applicable export laws and regulations, including those of Australia and the United States.",
    ],
  },
  {
    heading: "Governing Law",
    blocks: [
      "These Terms shall be governed by and construed in accordance with the laws of New South Wales, Australia, without regard to its conflict of law provisions, and its courts can hear any dispute about them. If you live in another country, you keep any consumer rights the law of that country gives you that cannot be excluded.",
    ],
  },
  {
    heading: "Severability",
    blocks: [
      "If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect. The invalid or unenforceable provision shall be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision.",
    ],
  },
  {
    heading: "Force Majeure",
    blocks: [
      "We shall not be liable for any failure or delay in performing our obligations under these Terms due to circumstances beyond our reasonable control, including but not limited to acts of God, natural disasters, war, terrorism, riots, embargoes, acts of civil or military authorities, fire, floods, pandemics, accidents, strikes, or shortages of transportation, facilities, fuel, energy, labor, or materials.",
    ],
  },
  {
    heading: "Assignment",
    blocks: [
      "You may not assign or transfer these Terms or any rights granted hereunder without our prior written consent. We may assign these Terms without restriction. Any attempted assignment in violation of this provision shall be void.",
    ],
  },
  {
    heading: "Entire Agreement",
    blocks: [
      `These Terms of Use, together with our ${PRIVACY_POLICY}, constitute the entire agreement between you and Serophin regarding the use of the Service and supersede any prior agreements, understandings, or arrangements between us, whether oral or written.`,
    ],
  },
  {
    heading: "Accessibility Commitment",
    blocks: [
      `We strive to make !tldr accessible to all users. While we work towards WCAG 2.1 Level AA compliance, we acknowledge that some content may not yet meet all standards. If you encounter accessibility issues, please ${CONTACT_US}.`,
    ],
  },
  {
    heading: "Language",
    blocks: [
      "These Terms are written in English. Any translations are provided for convenience only, and the English version shall prevail in case of conflicts.",
    ],
  },
];
